import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { inMarketTheme } from '@inmarket/inmarkit';
import { ThemeProvider } from '@mui/material';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { CreativeManagementIndexPage } from './pages/CreativeManagementIndexPage';
import '@fontsource/montserrat';
import '@fontsource/montserrat/300.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import { StudyProvider } from './context';
import { AiCreativePreTestingPage } from './pages/AiCreativePreTestingPage';
function App() {
    return (_jsx(ThemeProvider, { theme: inMarketTheme, children: _jsx(StudyProvider, { children: _jsx(BrowserRouter, { basename: "creativeManagement", children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(CreativeManagementIndexPage, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) }), _jsx(Route, { path: "/studies/:studyId", element: _jsx(AiCreativePreTestingPage, {}) })] }) }) }) }));
}
export default App;
